export const isNumber = (value) => {
    return typeof value === 'number';
}

export const toDecimalString = (value, locale, fractions = 0) => {
    return value.toLocaleString(locale, {minimumFractionDigits: fractions, maximumFractionDigits: fractions})
}